// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-5gC","title":"styles_title__1nljg"};